module.exports = __webpack_public_path__ + "media/images/egg_cover-74b5e33a3a84a55a9316e3b3f32a5528.jpg";